<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    :show-close="false"
    :modal-append-to-body="false"
    center
  >
    <div style="margin: 20px; text-align: center">
      <img src="/img/frameloader.gif" width="48" />
    </div>

    <p>{{ $t('Audiences_Segment_DialogMembersPreview_Progress') }}</p>
    <div class="m-top-50">
      <p>{{ $t('Audiences_Segment_DialogMembersPreview_Question') }}</p>
      <p>
        {{ $t('Audiences_Segment_DialogMembersPreview_Alert') }}
      </p>
    </div>

    <span slot="footer" class="dialog-footer">
      <!--<el-button type="danger" plain @click="cancel">
        {{ $t('Audiences_Segment_DialogMembersPreview_CancelBtn') }}
      </el-button>-->
      <el-button type="primary" plain @click="checkLater">
        {{ $t('Audiences_Segment_DialogMembersPreview_LaterBtn') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { EventBus } from '@/core/EventBus'

export default {
  methods: {
    checkLater() {
      EventBus.$emit('members-preview-hide')
    },
    cancel() {
      EventBus.$emit('members-preview-cancel')
    }
  }
}
</script>

<style scoped>
p {
  font-size: 16px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/components/MembersPreviewLoadingDialog.vue